/**
 * 将与 Modal API 无关的能力隔离出来，方便 Modal.vue 本身的扩展和阅读
 * mixin 负责：
 * 1. Modal 展示隐藏的动效与样式 [done]
 * 2. 遮罩 backdrop 的展示和隐藏 [done]
 * 3. zIndex 的计算 [done by ModalManager]
 * 4. 控制上父窗口的 overflow [done by ModalManager]
 *
 * 5. 针对多个同一 ID 的 Modal，只保留第一个（并发提示系统异常，登录失效等）- Done by MessageBox
 * 6. 针对阻断类型的 Modal，保证其顺序（处理完当前modal，才会弹出另一个modal）Done by MessageBox
 */
import ModalManager, { lockClass } from './ModalManager'
import KUuid from '../../core/utils/KUuid'
import KNextZIndex from '../../core/utils/KNextZIndex'
import KDevice from '../../core/utils/KDevice'
import raf from 'raf'
import $ from 'jquery'
import { getCorrectEventName } from '../../core/utils'
import { window } from 'ssr-window'

const transitionEnd = getCorrectEventName(window, 'transitionend')
const fromCenter = true

export default {
  props: {},
  data() {
    return {
      manager: ModalManager,
      // rendered: false, // 默认 slot 已渲染
      // opened: false, // 已打开
      closed: false, // 已关闭
      referenceEle: null,
      rendered: false, // 默认 slot 已渲染
      innerVisible: false,
    }
  },
  computed: {
    id() {
      return 'km-modal-' + KUuid()
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.destroyOnHide) {
            ModalManager.register(this)
          }

          if (!this.rendered) {
            this.rendered = true

            this.$nextTick(() => {
              this.innerVisible = val
            })
          } else {
            this.innerVisible = val
          }
          this.openModal()
        } else {
          this.closeModal()
          this.innerVisible = val
        }
      },
    },
  },
  beforeMount() {
    ModalManager.register(this)
  },
  mounted() {
    // if (this.innerVisible) {
    //   this.rendered = true
    // }
  },
  beforeDestroy() {
    ModalManager.closeModal(this.id)
    ModalManager.deregister(this.id)
    // ModalManager.restoreOpenterStyle()
  },
  methods: {
    getTransformOrigin(referenceBox, modalFlipBox) {
      let horizontal = 'center'
      let vertical = 'center'
      if (referenceBox.x < modalFlipBox.x) {
        horizontal = 'left'
      } else if (referenceBox.x > modalFlipBox.x) {
        horizontal = 'right'
      }

      if (referenceBox.y < modalFlipBox.y) {
        vertical = 'top'
      } else if (referenceBox.y > modalFlipBox.y) {
        vertical = 'bottom'
      }

      return `${horizontal} ${vertical}`
    },
    beforeEnter() {
      if (KDevice.noAnim) {
        return
      }
      if (ModalManager.modalStack.length <= 1) {
        this.referenceEle = this.focusedElement
      }
    },
    enter(el, done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      if (fromCenter) {
        this.enterMessageBox(done)
        return
      }

      if (this.isMessageBox) {
        this.enterMessageBox(done)
        return
      }

      if (!this.referenceEle) {
        this.enterWithoutReference(done)
        return
      }

      const modalDom = this.$refs.modal

      const referenceBox = this.referenceEle.getBoundingClientRect()
      const targetBox = modalDom.getBoundingClientRect()

      const deltaX = referenceBox.left - targetBox.left
      const deltaY = referenceBox.top - targetBox.top
      const widthScale = referenceBox.width / targetBox.width
      const heightScale = referenceBox.height / targetBox.height

      raf(() => {
        modalDom.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0px) scale3d(${widthScale}, ${heightScale}, 1)`
        modalDom.style.opacity = 0

        raf(() => {
          modalDom.style.opacity = 1
          modalDom.style.transformOrigin = this.getTransformOrigin(
            referenceBox,
            modalDom.getBoundingClientRect(),
          )
          modalDom.style.transform = ''
          modalDom.style.transition =
            'transform 400ms cubic-bezier(0.23, 1, 0.32, 1), opacity 400ms cubic-bezier(0.23, 1, 0.32, 1)'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    enterMessageBox(done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      const modalDom = this.$refs.modal

      raf(() => {
        modalDom.style.transform = `translate3d(0, 0, 0) scale(.6)`
        modalDom.style.opacity = 0

        raf(() => {
          modalDom.style.opacity = 1
          modalDom.style.transformOrigin = 'center center'
          modalDom.style.transform = ''
          // modalDom.style.transition = 'transform 120ms cubic-bezier(.39, 0, .45, 1.4), opacity 120ms linear'
          modalDom.style.transition =
            'transform 220ms cubic-bezier(0.23, 1, 0.32, 1), opacity 120ms linear'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    enterWithoutReference(done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      const modalDom = this.$refs.modal

      raf(() => {
        modalDom.style.transform = `translate3d(0, -20%, 0px)`
        modalDom.style.opacity = 0

        raf(() => {
          modalDom.style.opacity = 1
          modalDom.style.transformOrigin = 'center center'
          modalDom.style.transform = ''
          modalDom.style.transition = 'transform 300ms ease-in-out, opacity 300ms linear'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    afterEnter() {
      if (KDevice.noAnim) {
        return
      }

      const modalDom = this.$refs.modal

      modalDom.style.transformOrigin = 'none'
      modalDom.style.transform = ''
      modalDom.style.transition = 'none'
    },
    enterCancelled() {},
    beforeLeave(el) {
      // 防止出现双重滚动条
      $(el).addClass(lockClass)
    },
    leave(el, done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      if (fromCenter) {
        this.leaveMessageBox(done)
        return
      }

      if (this.isMessageBox) {
        this.leaveMessageBox(done)
        return
      }

      if (!this.referenceEle) {
        this.leaveWithoutReference(done)
        return
      }

      const modalDom = this.$refs.modal

      const modalBox = modalDom.getBoundingClientRect()
      const targetBox = this.referenceEle.getBoundingClientRect()

      const deltaX = targetBox.left - modalBox.left
      const deltaY = targetBox.top - modalBox.top
      const widthScale = targetBox.width / modalBox.width
      const heightScale = targetBox.height / modalBox.height

      raf(() => {
        modalDom.style.transition = 'transform 0s'
        modalDom.style.transform = ''

        raf(() => {
          modalDom.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0px) scale3d(${widthScale}, ${heightScale}, 1)`
          modalDom.style.opacity = 0
          modalDom.style.transition =
            'transform 300ms cubic-bezier(0.23, 1, 0.32, 1), opacity 300ms cubic-bezier(0.23, 1, 0.32, 1)'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    leaveMessageBox(done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      const modalDom = this.$refs.modal

      raf(() => {
        modalDom.style.transformOrigin = 'center center'
        modalDom.style.transform = ''
        modalDom.style.transition = 'transform 0s'

        raf(() => {
          modalDom.style.transform = `translate3d(0, 0, 0) scale(.6)`
          modalDom.style.opacity = 0
          modalDom.style.transition =
            'transform 100ms cubic-bezier(0.23, 1, 0.32, 1), opacity 100ms linear'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    leaveWithoutReference(done) {
      if (KDevice.noAnim) {
        done()
        return
      }

      const modalDom = this.$refs.modal

      raf(() => {
        modalDom.style.transformOrigin = 'center center'
        modalDom.style.transform = ''
        modalDom.style.transition = 'transform 0s'

        raf(() => {
          modalDom.style.transform = `translate3d(0, -20%, 0px)`
          modalDom.style.opacity = 0
          modalDom.style.transition = 'transform 200ms ease-out, opacity 200ms linear'

          $(modalDom).one(transitionEnd, () => {
            done()
          })
        })
      })
    },
    afterLeave(el) {
      $(el).removeClass(lockClass)

      this.referenceEle = null
      const modalDom = this.$refs.modal
      modalDom.style.transition = 'transform 0s'
      modalDom.style.transform = ''
      modalDom.style.transformOrigin = ''

      if (this.destroyOnHide) {
        this.rendered = false
        ModalManager.deregister(this.id)
      }
    },
    leaveCancelled() {},
    openModal() {
      ModalManager.openModal({
        id: this.id,
        zIndex: KNextZIndex(),
        mask: this.mask,
      })
    },
    closeModal() {
      ModalManager.closeModal(this.id)
    },
  },
}
